<div class="action-menu-container">
  <!-- Primary Actions (visible buttons) -->
  @if (hasPrimaryActions) {
    @for (action of config.primaryActions; track action.id) {
      <button
        type="button"
        class="action-btn primary-action"
        [class.action-disabled]="isActionDisabled(action)"
        [disabled]="isActionDisabled(action)"
        [title]="getActionTitle(action)"
        (click)="onPrimaryActionClick(action)"
      >
        @if (action.icon) {
          <i [class]="action.icon"></i>
        }
        @if (action.label) {
          <span class="action-label">{{ action.label }}</span>
        }
      </button>
    }
  }

  <!-- More Actions Dropdown -->
  @if (hasMenuActions) {
    <div class="dropdown-container">
      <button
        #triggerButton
        type="button"
        class="action-btn more-actions-btn"
        [class.is-open]="isMenuOpen"
        [title]="moreActionsButtonTitle"
        (click)="toggleMenu()"
      >
        @if (hasCustomMoreActionsIcon) {
          <i [class]="config.moreActionsIcon"></i>
        } @else {
          <i class="pi pi-ellipsis-v"></i>
        }
      </button>

      @if (isMenuOpen) {
        <div
          class="dropdown-menu dropdown-menu-fixed"
          role="menu"
          [style.top.px]="menuPosition.top"
          [style.left.px]="menuPosition.left"
        >
          @for (action of config.menuActions; track action.id) {
            <button
              type="button"
              role="menuitem"
              class="menu-item"
              [class.menu-item-disabled]="isActionDisabled(action)"
              [disabled]="isActionDisabled(action)"
              [title]="getActionTitle(action)"
              (click)="onMenuActionClick(action)"
            >
              <span class="menu-item-label">{{ action.label }}</span>
            </button>
          }
        </div>
      }
    </div>
  }
</div>
